var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "w-full lg:w-auto",
      class: _vm.buttonStyleClass,
      attrs: { form: _vm.form },
      on: { click: _vm.handleClick },
    },
    [
      _c("ButtonLoading", { attrs: { loading: _vm.loading } }, [
        _vm._v(_vm._s(_vm.message)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }